import axios from "axios";
import server from "../services/Connection/backEndLink";
// import { confirmCloseAlert } from "../functions/alerts"
import { status } from "../components/Status";
import { getValueCookie } from "./cookieService";
import { closeSession } from "../functions/closeSession";
// Alerts
import Swal from "sweetalert2";

// URL for http requests
const baseURLAuth = server.url;
// const baseURLAuth = "http://localhost:4800";

// Limit time for http requests
const REQUEST_TIMEOUT = 120000;

// Helper for alerts
// function showFriendlyError(customError) {
//   var title = "Espera";
//   var text = "Ocurrió un error al comunicarnos con el servidor. Intenta de nuevo.";

//   if (customError.code === "TIMEOUT") {
//     title = "Se tardó demasiado";
//     text = "La petición tardó más de lo permitido. Revisa tu internet e inténtalo de nuevo.";
//   } else if (customError.code === "NETWORK") {
//     title = "Sin conexión al servidor";
//     text = "No pudimos conectarnos. Verifica tu internet o intenta en unos minutos.";
//   } else if (typeof customError.status === "number") {
//     title = "Problema en el servidor";
//     text = "El servidor respondió con error (" + customError.status + "). Intenta de nuevo en unos minutos.";
//   }

//   Swal.fire({
//     icon: "error",
//     title: title,
//     text: text,
//     confirmButtonText: "Entendido"
//   });
// }

export const getInformationNoData = async (route) => {
    const URL = baseURLAuth + route;
    var responseBack = {
        data: [],
        status: status.Fail
    }
    await axios.get(URL).then(
        response => {
            responseBack = response.data
        }
    ).catch(error => {
        responseBack = { status: status.ServerFail, response: [] };
        // confirmCloseAlert('incorrect', 'Error in the Server Response: ' + error)
    })

    return responseBack;
}

export const GetWithInformation = async (route, data) => {
    const URL = baseURLAuth + route;
    var responseBack = {
        data: [],
        status: status.Fail
    }
    await axios.get(URL, { params: data }).then(
        response => {
            responseBack = response.data
        }
    ).catch(error => {
        responseBack = { status: status.ServerFail, response: [] };
        // confirmCloseAlert('incorrect', 'Error in the Server Response: ' + error)
    })

    return responseBack;
}

// export const getInformationWithData = async (route, data) => {
//     const URL = baseURLAuth + route;
//     var responseBack = {
//         data: [],
//         status: status.Fail
//     }

//     if (getValueCookie('userName')) {
//         await axios.post(URL, { data: data }).then(
//             response => {
//                 responseBack = response.data
//             }
//         ).catch(error => {
//             // confirmCloseAlert('incorrect', 'Error in the Server Response: ' + error)
//         })
//     } else {
//         closeSession()
//         window.location.reload()
//     }

//     return responseBack
// }

// Make http request to elixir app
export const getElixirApiData = async (route, data) => {
    // Validate session
    if (!getValueCookie('userName')) {
        // Remove cookies
        closeSession();

        // Redirect to login V2
        window.location.assign("/login");

        // Importante: rechazamos la promesa para que el caller lo pueda manejar si quiere
        throw new Error('Invalid user session');
    }

    try {
        // Use prefix before request the backend
        const server = "https://portalmanager.pro/api";
        const URL = server + route;

        const response = await axios.post(
            URL,
            { data: data },
            {
                timeout: REQUEST_TIMEOUT, // límite duro
            }
        );

        // Tu backend ya regresa el objeto { data, status, ... }
        return response.data;
    } catch (error) {
        // Catch errores V2 - Alert instead stop the App
        var customError = new Error("Error en la petición al backend");

        if (error && error.code === "ECONNABORTED") {
            customError.message = "La petición excedió el tiempo límite (timeout).";
            customError.code = "TIMEOUT";
        } else if (error && error.response) {
            customError.message = "Error " + error.response.status + " en el servidor.";
            customError.status = error.response.status;
        } else if (error && error.request) {
            customError.message = "No se pudo conectar con el servidor.";
            customError.code = "NETWORK";
        }

        console.log("getInformationWithData error:", customError.message);

        // showFriendlyError(customError);

        // IMPORTANTE: no truenes la app
        return {
            data: [],
            status: status.Fail,
            message: customError.message,
            code: customError.code || null,
            httpStatus: customError.status || null
        };
    }
};

// Make http requests V2 - Backendv1
export const getInformationWithDataB1 = async (route, data) => {
    // Validate session
    if (!getValueCookie('userName')) {
        // Remove cookies
        closeSession();

        // Redirect to login V2
        window.location.assign("/logout");

        // Importante: rechazamos la promesa para que el caller lo pueda manejar si quiere
        throw new Error('Invalid user session');
    }

    try {
        // Use prefix before request the backend
        const prefix = getValueCookie('apiPrefix');
        // const apiPrefix = prefix ? prefix : '';
        // const URL =  'baseURLAuth' + apiPrefix + route;
        const URL =  'https://apiportalmanager.mayaland.store' + route;
        // Get JWT
        const jwtToken = getValueCookie('sessionAuthToken');

        const response = await axios.post(
            URL,
            { data: data },
            {
                timeout: REQUEST_TIMEOUT,
                headers: {
                    Authorization: `Bearer: ${jwtToken}`
                }
            }
        );

        // Validar session
        if ("error" in response.data) {
            if (response.data.error === "INVALID_CREDENTIALS" || response.data.error === "TOKEN_INVALID_OR_EXPIRED") {
                Swal.fire({
                    title: `Invalid session or expired`,
                    text: "Please, login again.",
                    icon: 'warning',
                    confirmButtonColor: '#14398a',
                    cancelButtonColor: '#626262',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, Login again.',
                    cancelButtonText: 'No, cancel.',
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        window.location.assign("/logout");
                    }
                });

                return {status: {code: -1}};
            }

        }

        // Tu backend ya regresa el objeto { data, status, ... }
        return response.data;
    } catch (error) {
        // Catch errores V2 - Alert instead stop the App
        var customError = new Error("Error en la petición al backend");

        if (error && error.code === "ECONNABORTED") {
            customError.message = "La petición excedió el tiempo límite (timeout).";
            customError.code = "TIMEOUT";
        } else if (error && error.response) {
            customError.message = "Error " + error.response.status + " en el servidor.";
            customError.status = error.response.status;
        } else if (error && error.request) {
            customError.message = "No se pudo conectar con el servidor.";
            customError.code = "NETWORK";
        }

        console.log("getInformationWithData error:", customError.message);

        // showFriendlyError(customError);

        // IMPORTANTE: no truenes la app
        return {
            data: [],
            status: status.Fail,
            message: customError.message,
            code: customError.code || null,
            httpStatus: customError.status || null
        };
    }
};
export const getInformationWithData = async (route, data) => {
    // Validate session
    if (!getValueCookie('userName')) {
        // Remove cookies
        closeSession();

        // Redirect to login V2
        window.location.assign("/logout");

        // Importante: rechazamos la promesa para que el caller lo pueda manejar si quiere
        throw new Error('Invalid user session');
    }

    try {
        // Use prefix before request the backend
        const prefix = getValueCookie('apiPrefix');
        const apiPrefix = prefix ? prefix : '';
        const URL =  baseURLAuth + apiPrefix + route;
        // Get JWT
        const jwtToken = getValueCookie('sessionAuthToken');

        const response = await axios.post(
            URL,
            { data: data },
            {
                timeout: REQUEST_TIMEOUT,
                headers: {
                    Authorization: `Bearer: ${jwtToken}`
                }
            }
        );

        // Validar session
        if ("error" in response.data) {
            if (response.data.error === "INVALID_CREDENTIALS" || response.data.error === "TOKEN_INVALID_OR_EXPIRED") {
                Swal.fire({
                    title: `Invalid session or expired`,
                    text: "Please, login again.",
                    icon: 'warning',
                    confirmButtonColor: '#14398a',
                    cancelButtonColor: '#626262',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, Login again.',
                    cancelButtonText: 'No, cancel.',
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        window.location.assign("/logout");
                    }
                });

                return {status: {code: -1}};
            }

        }

        // Tu backend ya regresa el objeto { data, status, ... }
        return response.data;
    } catch (error) {
        // Catch errores V2 - Alert instead stop the App
        var customError = new Error("Error en la petición al backend");

        if (error && error.code === "ECONNABORTED") {
            customError.message = "La petición excedió el tiempo límite (timeout).";
            customError.code = "TIMEOUT";
        } else if (error && error.response) {
            customError.message = "Error " + error.response.status + " en el servidor.";
            customError.status = error.response.status;
        } else if (error && error.request) {
            customError.message = "No se pudo conectar con el servidor.";
            customError.code = "NETWORK";
        }

        console.log("getInformationWithData error:", customError.message);

        // showFriendlyError(customError);

        // IMPORTANTE: no truenes la app
        return {
            data: [],
            status: status.Fail,
            message: customError.message,
            code: customError.code || null,
            httpStatus: customError.status || null
        };
    }
};


export const getDetailSO = async (route, data) => {
    const URL = baseURLAuth + route
    var responseBack = {
        data: [],
        status: status.Fail
    }

    if (getValueCookie('userName')) {
        try {
            const response = await axios.post(URL, { data: data }, { timeout: 90000 })
            responseBack = response.data
        }
        catch (error) {
            if (error.code === 'ECONNABORTED') {
                console.error('Request timed out')
            } else {
                console.error('Request failed', error.message)
            }
        }
        // await axios.post(URL, { data: data }).then(
        //     response => {
        //         responseBack = response.data
        //     }
        // ).catch(error => {
        //     confirmCloseAlert('incorrect', 'Error in the Server Response: ' + error)
        // })
    } else {
        window.location.reload()
    }

    return responseBack
}

export const saveJsonData = async (route, data) => {
    const URL = baseURLAuth + route
    await axios.post(URL, { data }).then().catch(error => {
        // confirmCloseAlert('incorrect', 'Error in the Server Response: ' + error)
    })
}

export const create_Delete_Update_Information = async (route, data) => {
    // Validate session
    if (!getValueCookie('userName')) {
        // Remove cookies
        closeSession();

        // Redirect to login V2
        window.location.assign("/logout");

        // Importante: rechazamos la promesa para que el caller lo pueda manejar si quiere
        throw new Error('Invalid user session');
    }

    try {
        // Use prefix before request the backend
        const prefix = getValueCookie('apiPrefix');
        const apiPrefix = prefix ? prefix : '';
        const URL =  baseURLAuth + apiPrefix + route;
        // Get JWT
        const jwtToken = getValueCookie('sessionAuthToken');

        var responseBack = {
            data: [],
            status: status.Fail
        }

        await axios.post(
            URL,
            { data: data },
            {
                timeout: REQUEST_TIMEOUT,
                headers: {
                    Authorization: `Bearer: ${jwtToken}`
                }
            }
        ).then(
            response => {
                responseBack = response.data
            }
        ).catch(error => {
            // confirmCloseAlert('incorrect', 'Error in the Server Response: ' + error)
            console.log("create_Delete_Update_Information. Error: ", error);
        });

        return responseBack;

    } catch (error) {
        // Catch errores V2 - Alert instead stop the App
        var customError = new Error("Error en la petición al backend");

        if (error && error.code === "ECONNABORTED") {
            customError.message = "La petición excedió el tiempo límite (timeout).";
            customError.code = "TIMEOUT";
        } else if (error && error.response) {
            customError.message = "Error " + error.response.status + " en el servidor.";
            customError.status = error.response.status;
        } else if (error && error.request) {
            customError.message = "No se pudo conectar con el servidor.";
            customError.code = "NETWORK";
        }

        console.log("getInformationWithData error:", customError.message);

        // showFriendlyError(customError);

        // IMPORTANTE: no truenes la app
        return {
            data: [],
            status: status.Fail,
            message: customError.message,
            code: customError.code || null,
            httpStatus: customError.status || null
        };
    }
}

export const uploadFile = async (route, file) => {
    const prefix = getValueCookie('apiPrefix');
    const apiPrefix = prefix ? prefix : '';
    const URL =  baseURLAuth + apiPrefix + route;
    // const URL = baseURLAuth + route
    var responseBack = {
        data: [],
        status: status.Fail
    }

    if (getValueCookie('userName')) {
        await axios.post(URL, file, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(
            response => {
                responseBack = response.data
            }
        ).catch(error => {
            // confirmCloseAlert('incorrect', 'Error in the Server Response: ' + error)
        })
    } else {
        window.location.reload()
    }


    return responseBack
}


export const getInformationWithDataGlobalSales = async (route, data) => {
    const URL = 'https://apiglobalsales.mayaland.store' + route
    var responseBack = {
        data: [],
        status: status.Fail
    }
    if (getValueCookie('userName')) {
        await axios.post(URL, data).then(
            response => {
                responseBack = response.data
            }
        ).catch(error => {
            // confirmCloseAlert('incorrect', 'Error in the Server Response: ' + error)
        })
    } else {
        window.location.reload()
    }

    return responseBack
}

export default { getInformationNoData, create_Delete_Update_Information, getInformationWithData, getInformationWithDataGlobalSales }

